__turbopack_context__.v({
  "app_light_theme": "PageItem-module-scss-module__GKfKea__app_light_theme",
  "link": "PageItem-module-scss-module__GKfKea__link",
  "pageItem": "PageItem-module-scss-module__GKfKea__pageItem",
});
